import React from 'react';
import ImageGalleryweekly from '../components/ImageGalleryweekly';
import IRCTVDonationCard from "./IRCTVDonationCard";

const IRCWEEKLY = () => {
        const helplineBaseAmount = 10000;

    return (
        <>
            <div className="about-us-container">
                <section className="activities-details">
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            marginBottom: '10px',
                            padding: '8px 10px',
                            backgroundColor: '#255fe8',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        ← Back to All Activities
                    </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>
                            All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
                        </p>
                    </div>

                    <ImageGalleryweekly />

                    {/* IRC 10 Days WEEKLY */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>WEEKLY LECTURES</h3>
                        </div>
                        <div className="activity-content">
                            <p>
                                IRC conducts weekly lectures for Muslims and non-Muslims, delivered by various speakers from IRC on socio-religious issues, followed by an open Question & Answer session for both ladies and gents at different places in and around the city of Chhatrapati Sambhajinagar (Aurangabad), aiming to promote better understanding and social harmony. IRC also conducts a permanent weekly lecture at its head office every Saturday at 9:15 PM.
                            </p>
                        </div>
                        <IRCTVDonationCard
                            title="WEEKLY LECTURES"
                  baseAmount={helplineBaseAmount}

                            subtitle="Your donation makes a difference"
                            description="Donate Us continue providing quality content and services to our community."
                            amount="₹5000"
                            purpose="Cause: SPONSER A LECTURE"
                        />
                    </div>
                </section>
            </div>
        </>
    );
};

export default IRCWEEKLY;
